import(/* webpackMode: "eager" */ "/home/runner/work/play/play/apps/play-portal/src/app/games/(details)/[uid]/loading.tsx");
